module.exports = __webpack_public_path__ + "./images/tournament-rules-icon.23b72cf02657ac0b18007ee36d4ce1c4.png";